/**
 * Video Block JavaScript
 * Handles play overlay interactions and video player enhancements
 */
document.addEventListener('DOMContentLoaded', function() {
    initVideoBlocks();
});

function initVideoBlocks() {
    const videoBlocks = document.querySelectorAll('.video-block');
    
    videoBlocks.forEach(initVideoBlock);
}

function initVideoBlock(blockElement) {
    const playOverlay = blockElement.querySelector('.video-block__play-overlay');
    const videoPlayer = blockElement.querySelector('.video-block__player');
    
    if (playOverlay && videoPlayer) {
        // Handle play overlay click
        playOverlay.addEventListener('click', function() {
            playVideo(videoPlayer, playOverlay);
        });
        
        // Handle video play events
        videoPlayer.addEventListener('play', function() {
            hidePlayOverlay(playOverlay);
        });
        
        // Handle video pause events
        videoPlayer.addEventListener('pause', function() {
            showPlayOverlay(playOverlay);
        });
        
        // Handle video end events
        videoPlayer.addEventListener('ended', function() {
            showPlayOverlay(playOverlay);
        });
    }
    
    // Handle lazy loading
    const lazyVideos = blockElement.querySelectorAll('video[loading="lazy"]');
    lazyVideos.forEach(setupLazyVideo);
    
    // Handle responsive adjustments
    handleResponsiveVideo(blockElement);
}

function playVideo(videoElement, overlayElement) {
    if (videoElement) {
        videoElement.play().catch(function(error) {
            console.warn('Video play failed:', error);
        });
        
        hidePlayOverlay(overlayElement);
    }
}

function hidePlayOverlay(overlayElement) {
    if (overlayElement) {
        overlayElement.style.opacity = '0';
        overlayElement.style.pointerEvents = 'none';
        
        setTimeout(function() {
            overlayElement.style.display = 'none';
        }, 300);
    }
}

function showPlayOverlay(overlayElement) {
    if (overlayElement) {
        overlayElement.style.display = 'flex';
        overlayElement.style.pointerEvents = 'auto';
        
        setTimeout(function() {
            overlayElement.style.opacity = '1';
        }, 10);
    }
}

function setupLazyVideo(videoElement) {
    // Intersection Observer for lazy loading
    if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    
                    // Load video sources
                    const sources = video.querySelectorAll('source');
                    sources.forEach(function(source) {
                        if (source.dataset.src) {
                            source.src = source.dataset.src;
                            source.removeAttribute('data-src');
                        }
                    });
                    
                    if (video.dataset.src) {
                        video.src = video.dataset.src;
                        video.removeAttribute('data-src');
                    }
                    
                    video.load();
                    videoObserver.unobserve(video);
                }
            });
        }, {
            rootMargin: '50px 0px'
        });
        
        videoObserver.observe(videoElement);
    }
}

function handleResponsiveVideo(blockElement) {
    const wrapper = blockElement.querySelector('.video-block__wrapper');
    const container = blockElement.querySelector('.video-block__container-inner');
    
    if (!wrapper || !container) return;
    
    function adjustVideoSize() {
        const blockWidth = blockElement.offsetWidth;
        
        // Adjust font sizes and spacing based on container width
        if (blockWidth < 576) {
            blockElement.classList.add('video-block--mobile');
        } else {
            blockElement.classList.remove('video-block--mobile');
        }
        
        if (blockWidth < 768) {
            blockElement.classList.add('video-block--tablet');
        } else {
            blockElement.classList.remove('video-block--tablet');
        }
    }
    
    // Initial adjustment
    adjustVideoSize();
    
    // Adjust on window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(adjustVideoSize, 250);
    });
}

// YouTube/Vimeo iframe API enhancements
function enhanceEmbeddedVideos() {
    const iframes = document.querySelectorAll('.video-block__embed iframe');
    
    iframes.forEach(function(iframe) {
        // Add responsive classes
        iframe.classList.add('video-block__embed-iframe');
        
        // Handle load events
        iframe.addEventListener('load', function() {
            const container = iframe.closest('.video-block__container-inner');
            if (container) {
                container.classList.add('video-block__container-inner--loaded');
            }
        });
    });
}

// Initialize embedded video enhancements
document.addEventListener('DOMContentLoaded', enhanceEmbeddedVideos);

// Accessibility enhancements
function enhanceVideoAccessibility() {
    const videoBlocks = document.querySelectorAll('.video-block');
    
    videoBlocks.forEach(function(block) {
        const playButton = block.querySelector('.video-block__play-overlay');
        const video = block.querySelector('.video-block__player');
        
        if (playButton && video) {
            // Add ARIA labels
            playButton.setAttribute('role', 'button');
            playButton.setAttribute('aria-label', 'Play video');
            playButton.setAttribute('tabindex', '0');
            
            // Handle keyboard navigation
            playButton.addEventListener('keydown', function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    playButton.click();
                }
            });
            
            // Update ARIA label based on video state
            video.addEventListener('play', function() {
                playButton.setAttribute('aria-label', 'Video playing');
            });
            
            video.addEventListener('pause', function() {
                playButton.setAttribute('aria-label', 'Play video');
            });
        }
    });
}

// Initialize accessibility enhancements
document.addEventListener('DOMContentLoaded', enhanceVideoAccessibility);

// Export functions for potential external use
window.VideoBlock = {
    init: initVideoBlocks,
    initSingle: initVideoBlock,
    playVideo: playVideo,
    hidePlayOverlay: hidePlayOverlay,
    showPlayOverlay: showPlayOverlay
};